import "./booking.css";

document.addEventListener(
  "DOMContentLoaded",
  () => {
    const cross = document.querySelector(".booking_cross");
    if (!cross) return;
    cross.addEventListener("click", () => {
      const booking_popup = document.getElementById("booking_popup");
      booking_popup.classList.remove("booking_popup_open");
    });
    window.addEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        const booking_popup = document.getElementById("booking_popup");
        booking_popup.classList.remove("booking_popup_open");
      }
    });
  },
  false,
);
